import { mapActions, mapGetters, mapMutations } from 'vuex';
import checkPartner from './checkPartner';
import checkUserVerification from '@/mixins/checkUserVerification';

export default {
  mixins: [checkPartner, checkUserVerification],
  computed: {
    ...mapGetters({
      dialog: 'profile/dashboard/dialog',
      dialogParams: 'profile/dashboard/dialogParams',
      dialogFrom: 'profile/dialogPage/dialogFrom'
    })
  },
  methods: {
    async checkUrlForDialog() {
      await this.checkUserVerification(false);
      if (this.$auth.user.verify.email && this.$route.query.pd?.length) {
        if (this.$route.query.pd === 'authorization') {
          await this.$router.push(this.$localePath('benefitManagement'));
          return;
        }

        await this.$store.dispatch('profile/dashboard/setDialog', this.$route.query.pd);
        return;
      }

      if (!this.showInsuranceProviderBenefitBox && this.$route.query.pd === 'insurance-benefits') {
        await this.$store.dispatch('profile/dashboard/setDialog', false);
        return;
      }

      await this.$store.dispatch('profile/dashboard/setDialog', false);
    },
    ...mapMutations({
      setDialog: 'profile/dashboard/setDialog'
    }),
    ...mapActions({
      deleteDialogParams: 'profile/dashboard/deleteDialogParams'
    })
  },
  watch: {
    async dialog(newValue, oldValue) {
      if (!oldValue || newValue !== this.$route.query.pd) {
        const routeQueryParams = this.$route.query;

        for (const prop in this.dialogParams) {
          delete routeQueryParams[prop];
        }

        let query = {
          ...routeQueryParams
        };

        if (newValue) {
          query.pd = newValue;
        } else {
          delete query.pd;
        }

        if (Object.keys(this.dialogParams).length) {
          if (newValue) {
            query = {
              ...query,
              ...this.dialogParams
            };
          } else {
            for (const prop in this.dialogParams) {
              delete query[prop];
            }
            this.deleteDialogParams();
          }
        }

        if (this.isMobileApp) {
          if (newValue) {
            await this.$router.push(
              this.$localePath({
                name: 'profileDialog',
                query,
                params: { savePosition: true }
              })
            );
          } else if (this.currentPath === 'profileDialog') {
            // don't run this redirect if user was redirected to another path from dialog (button click)
            // dialog is closed (newValue === true), but user is already on another page -> currentPath !== profileDialog
            if (this.dialogFrom) {
              await this.$router.push(
                this.$localePath(
                  {
                    name: this.dialogFrom.name.split('___')[0],
                    query: this.dialogFrom.query,
                    params: this.dialogFrom.params
                  },
                  this.$i18n.locale
                )
              );
            } else {
              await this.$router.push(this.$localePath('dashboard'));
            }
          }
        } else {
          await this.$router.push(
            this.$localePath({
              name: this.currentPath,
              query,
              params: { ...this.$route.params, savePosition: true }
            })
          );
        }
      }
    }
  }
};
